<app-menu-common url="sales"></app-menu-common>

<div class="contract-page">
  @switch (status) {
    @case ('loading') {
      <!-- Rien ici : la fenêtre « Chargement du contrat… » (spin.block) suffit, un second spinner derrière la doublait. -->
    }
    @case ('missing') {
      <div class="page-state">
        <mat-icon class="state-icon">search_off</mat-icon>
        <div class="state-title">Document inexistant</div>
        <div class="state-sub">Aucune pièce n° {{ id || '—' }}.</div>
      </div>
    }
    @case ('failed') {
      <!-- Pièce illisible (cycle au format ancien…) : /lifecycle le tolère, le Planning reste consultable dessous. -->
      <div class="page-state failed">
        <mat-icon class="state-icon">error_outline</mat-icon>
        <div class="state-title">Lecture du contrat en échec</div>
        @if (loadError) { <div class="state-sub load-error">{{ loadError }}</div> }
        <div class="state-sub">Le planning de facturation du dossier reste consultable ci-dessous.</div>
        <button mat-stroked-button class="hdr-btn" (click)="load()"><mat-icon>refresh</mat-icon>Réessayer</button>
      </div>
      <div class="table-card degraded">
        <app-rental-planning mode="page" [visibleLineIds]="null"></app-rental-planning>
      </div>
    }
    @case ('not-rental') {
      <div class="page-state">
        <mat-icon class="state-icon">info</mat-icon>
        @if (notRental?.parentId) {
          <div class="state-title">Cette pièce est une facture du contrat de location n° {{ notRental?.parentId }}</div>
          <a mat-stroked-button class="hdr-btn" [routerLink]="['/rental', notRental?.parentId]"><mat-icon>assignment</mat-icon>Ouvrir le contrat n° {{ notRental?.parentId }}</a>
        } @else {
          <div class="state-title">La pièce n° {{ id }} n'est pas un contrat de location ({{ notRental?.docType }})</div>
        }
        <a mat-stroked-button class="hdr-btn" [routerLink]="['/sales/quotation', id]"><mat-icon>open_in_new</mat-icon>Ouvrir dans l'écran actuel</a>
      </div>
    }
    @case ('ok') {
      <!-- Brouillon (/rental/nouveau) : en-tête réglé puis validé, figé ensuite ; rien n'est écrit avant le premier matériel (documentation.html#front.sales.rental-contract.creation-chapeau-patient) -->
      @if (draft) {
        <div class="toolbar-card draft-bar">
          <div class="title-block">
            @if (headerValidated) { <ng-container [ngTemplateOutlet]="partiesTpl"></ng-container> } @else { <div class="customer-name">Nouvelle location</div> }
            <div class="contract-line">
              <span class="state-pill" matTooltip="Rien n'est enregistré avant le premier matériel livré">Non enregistré</span>
              @if (another) { <span class="state-pill" matTooltip="Un dossier de plus pour ce patient, à côté des autres">Second dossier</span> }
            </div>
          </div>
          @if (!headerValidated) {
            <!-- Qui est livré, à quelle adresse ; qui paie, à quelle adresse : le nom au-dessus, son adresse dessous (JP 29/10, lisibilité avant densité). -->
            <div class="draft-col">
              <div class="draft-field">
                <span class="draft-label">Patient ou établissement</span>
                <app-search-partner [currentPartner]="draftPatient" width="460px" [showSelectionInInput]="true" [resetComponentSubject]="resetDraftPatient" (partnerChange)="draftPatientChange($event)" (partnerUpdated)="draftPatientRefreshed($event)"></app-search-partner>
              </div>
              <div class="draft-field">
                <span class="draft-label">Adresse de livraison</span>
                @if (formGroup) {
                  <div [formGroup]="formGroup"><smart-select class="draft-select" height="32px" optionHeight="32px" [items]="delivAddresses" formControlName="addr_deliv" [bindLabelFn]="formatAddress" bindValue="id"></smart-select></div>
                } @else {
                  <div class="draft-select draft-placeholder">—</div>
                }
              </div>
            </div>
            <div class="draft-col">
              <div class="draft-field">
                <span class="draft-label">{{ payerDistinct ? 'Tiers payeur' : 'Payeur' }}</span>
                <div class="payer-row">
                  <mat-checkbox class="draft-check" [(ngModel)]="payerDistinct" (change)="payerToggle()" [disabled]="draftBusy" matTooltip="HAD, établissement… : facturé au tiers, livré chez le patient">Payé par un tiers</mat-checkbox>
                  @if (payerDistinct) {
                    <app-search-partner [currentPartner]="draftPayer" width="420px" [showSelectionInInput]="true" [resetComponentSubject]="resetDraftPayer" (partnerChange)="draftPayerChange($event)" (partnerUpdated)="draftPayerRefreshed($event)"></app-search-partner>
                  }
                </div>
              </div>
              <div class="draft-field">
                <span class="draft-label">Adresse de facturation</span>
                @if (formGroup) {
                  <div [formGroup]="formGroup"><smart-select class="draft-select" height="32px" optionHeight="32px" [items]="billAddresses" formControlName="addr_bill" [bindLabelFn]="formatAddress" bindValue="id"></smart-select></div>
                } @else {
                  <div class="draft-select draft-placeholder">—</div>
                }
              </div>
            </div>
            <span class="spacer"></span>
            <button mat-flat-button class="hdr-btn accent" (click)="validateHeader()" [disabled]="!!draftHint || draftBusy" [disabledInteractive]="true" [matTooltip]="draftHint ?? 'Ouvre le dossier du patient s\'il en a déjà un ; sinon l\'en-tête se fige et l\'on passe aux matériels'"><mat-icon>check</mat-icon>Valider l'en-tête</button>
          } @else {
            <span class="spacer"></span>
            @if (editable) {
              <button mat-flat-button class="hdr-btn accent success" (click)="openAddForm()" [disabled]="saving"><mat-icon>add</mat-icon>Ajouter un matériel</button>
            }
          }
          <button mat-stroked-button class="hdr-btn" (click)="cancelDraft()" [disabled]="saving" matTooltip="Revenir à la page précédente, ou à la liste des locations"><mat-icon>close</mat-icon>Annuler</button>
        </div>
        @if (!headerValidated && draftHint; as h) { <div class="draft-hint">{{ h }}</div> }
      } @else {
      <!-- En-tête : à qui, quel contrat, et les seuls gestes de la page (documentation.html#front.sales.rental-contract) -->
      <div class="toolbar-card">
        <div class="title-block">
          <ng-container [ngTemplateOutlet]="partiesTpl"></ng-container>
          <div class="contract-line">
            <span>Contrat de location n°&nbsp;{{ id }}@if (openedOn) { · ouvert le {{ openedOn }} }</span>
            <span class="state-pill">{{ stateLabel }}</span>
            <span class="version-tag" matTooltip="Nouvel écran du contrat, à comparer avec l'écran actuel">V2</span>
            @if (!editable) { <span class="readonly-tag" matTooltip="Les lignes d'un contrat ne se modifient qu'en création ou en préparation ; les décisions de facturation restent possibles">Lecture seule</span> }
          </div>
          <!-- Dossier unique par patient : le principal et les autres, en liens (documentation.html#front.sales.rental-contract.creation-chapeau-patient) -->
          @if (patientId) {
            <div class="others-line">
              @if (mainId) {
                <span class="main-ref" matTooltip="Le plus ancien dossier de ce patient qui accepte des matériels : « Nouvelle location » ouvre celui-là">Dossier principal : <a [routerLink]="['/rental', mainId]" [queryParams]="{ vue: 'planning' }">n°&nbsp;{{ mainId }}</a></span>
              }
              @if (others.length) {
                <span>Autres dossiers :</span>
                @for (d of others; track d.id) {
                  <a [routerLink]="['/rental', d.id]" [queryParams]="{ vue: 'planning' }" [matTooltip]="otherTip(d)">n°&nbsp;{{ d.id }}</a>
                }
              }
              <a class="another" [routerLink]="['/rental/nouveau']" [queryParams]="{ customer: patientId, autre: 1 }" matTooltip="Créer un second dossier pour ce patient (autre payeur…)">+ Autre dossier</a>
            </div>
          }
        </div>
        <!-- Boutons : ils passent sur deux rangées faute de place, les cartes du bénéficiaire et du payeur ne rétrécissent jamais (JP 29/10). -->
        <div class="hdr-actions">
        <!-- Points à vérifier : la liste s'ouvre au survol (ou au clic, au clavier) ; chaque point mène au geste qui le règle. -->
        @if (problems.length; as n) {
          <div class="problems" #problemsWrap (mouseenter)="openProblems(problemsWrap)" (mouseleave)="problemsOpen = false" (focusout)="problemsFocusOut($event)" (keydown.escape)="problemsOpen = false">
            <button type="button" class="anomaly-chip" (click)="openProblems(problemsWrap)" [attr.aria-expanded]="problemsOpen" aria-controls="contract-problems">⚠ {{ plural(n, 'point à vérifier', 'points à vérifier') }}</button>
            @if (problemsOpen) {
              <div class="problems-pop" id="contract-problems" [class.left]="problemsLeft" [style.max-width.px]="problemsMax">
                <div class="problems-list">
                  @for (p of problems; track $index) {
                    <button type="button" class="problem" [class.blocking]="p.blocked" (click)="onProblem(p)">
                      <span class="who">{{ p.who }}</span>
                      <span class="what">{{ p.what }}@if (p.blocked) { <span class="pill pill-anomaly">bloquante</span> }</span>
                      <span class="act">{{ problemAction(p) }}<mat-icon>chevron_right</mat-icon></span>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (editable) {
          <button mat-flat-button class="hdr-btn accent success" (click)="openAddForm()" [disabled]="saving"><mat-icon>add</mat-icon>Ajouter un matériel</button>
          <button mat-stroked-button class="hdr-btn" (click)="openDeliveryDialog()" [disabled]="saving || !!deliveryBlockedReason" [disabledInteractive]="true" [matTooltip]="deliveryBlockedReason ?? 'Livraisons et reprises du contrat'">
            <mat-icon>local_shipping</mat-icon>Planifier les livraisons
          </button>
          <button mat-stroked-button class="hdr-btn" (click)="newSaleOrder()" [disabled]="saving" [disabledInteractive]="true" [matTooltip]="saving ? 'Un enregistrement est en cours' : 'Commande de vente liée au dossier (même client, mêmes adresses) : sa commande en création s\'ouvre, sinon une neuve ; on y saisit les articles, elle se valide au passage qui la livre'">
            <mat-icon>shopping_cart</mat-icon>Vendre un article
          </button>
        }
        @if (customer?.id && !distinctPayer) {
          <a mat-stroked-button class="hdr-btn" [routerLink]="['/rental/payeur', customer.id]" [queryParams]="display === 'planning' ? { vue: 'planning' } : {}" matTooltip="Tous les dossiers de location payés par ce client, sur une même page"><mat-icon>folder_shared</mat-icon>Tous ses dossiers</a>
        }
        <!-- Avec les autres actions du dossier (JP 03/11/2026) : lettre de renouvellement d'ordonnance du patient, route de l'écran du lot. -->
        @if (hasRxLines && patientId) {
          <button mat-stroked-button class="hdr-btn" (click)="printRenewal()" [disabled]="renewalPrinting" matTooltip="Lettre au patient : ses matériels dont l'ordonnance manque ou expire bientôt (délai des paramètres de vente), tous dossiers confondus"><mat-icon>medical_information</mat-icon>Demande de renouvellement d'ordonnance</button>
        }
        <!-- Clôture (JP 29/10/2026) : toutes les lignes louées et vendues figées ; le passage clôt aussi d'office les lignes soldées. -->
        @if (closure; as c) {
          @if (c.lines > 0 && c.closed === c.lines) {
            <span class="state-pill closed" matTooltip="Toutes les lignes louées et vendues sont closes : ni facture, ni avoir, ni décision tant que le dossier n'est pas rouvert">Dossier clos</span>
          } @else if (c.lines > 0) {
            <button mat-stroked-button class="hdr-btn" (click)="closeDossier()" [disabled]="closureBusy" matTooltip="Figer toutes les lignes louées et vendues ; refusé tant qu'une location court ou qu'il reste à facturer"><mat-icon>lock</mat-icon>Clôturer@if (c.closed) { <span class="muted">&nbsp;({{ c.closed }}/{{ c.lines }} closes)</span> }</button>
          }
          @if (c.closed > 0) {
            <button mat-stroked-button class="hdr-btn" (click)="reopenDossier()" [disabled]="closureBusy" matTooltip="Rouvrir les lignes closes pour corriger, puis clôturer à nouveau ; motif demandé"><mat-icon>lock_open</mat-icon>Rouvrir</button>
          }
        }
        <a mat-stroked-button class="hdr-btn" [routerLink]="['/sales/quotation', id]" matTooltip="La même pièce dans l'écran actuel"><mat-icon>open_in_new</mat-icon>Ouvrir dans l'écran actuel</a>
        </div>
      </div>
      }

      <!-- Résumé : compte des matériels (faits de BL), montant à facturer rendu par le moteur (aperçu du passage) ; grisé en brouillon -->
      <div class="tiles" [class.greyed]="draft" [attr.inert]="draft ? '' : null">
        <div class="tile"><span class="tile-label">En place</span><span class="tile-value">{{ view.tiles.inPlace }}</span></div>
        <div class="tile"><span class="tile-label">À livrer</span><span class="tile-value">{{ view.tiles.toDeliver }}</span></div>
        <div class="tile"><span class="tile-label">À récupérer</span><span class="tile-value">{{ view.tiles.toCollect }}</span></div>
        <div class="tile">
          <span class="tile-label">Repris</span>
          <span class="tile-value">{{ view.tiles.returned }}</span>
          @if (view.tiles.returnedWithAnomaly > 0) { <span class="tile-note">dont {{ view.tiles.returnedWithAnomaly }} avec anomalie</span> }
        </div>
        <div class="tile invoicing">
          <span class="tile-label"><span matTooltip="Même calcul que la facturation des locations, sans rien émettre">À facturer</span> <span class="tile-unit">{{ taxLabel }}</span>
            <button type="button" class="icon-btn" (click)="refreshInvoicing()" [disabled]="invoicing.loading" aria-label="Recalculer" matTooltip="Recalculer"><mat-icon>refresh</mat-icon></button>
            @if (invoicing.loading && invoicing.received) {
              <mat-progress-spinner class="tile-spin" mode="indeterminate" diameter="14" strokeWidth="2" color="primary" aria-label="Recalcul en cours"></mat-progress-spinner>
            }
          </span>
          @if (!invoicing.received) {
            @if (invoicing.loading) {
              <span class="tile-wait"><mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary"></mat-progress-spinner>Calcul…</span>
            } @else if (invoicing.error) {
              <span class="tile-reason error">Calcul impossible : {{ invoicing.error }}</span>
            }
          } @else {
            @if (invoiceMain !== null) {
              <span class="tile-value amount">{{ m(invoiceMain) }}&nbsp;€</span>
              <span class="tile-sub">
                <span class="nowrap">{{ m(invoiceOther) }}&nbsp;€ {{ isHt ? 'TTC' : 'HT' }}</span>
                @if (invoiceCredit !== 0) { <span class="nowrap credit" matTooltip="Avoirs émis à part au même passage : ils ne sont pas compris dans le montant à facturer">· avoirs : {{ m(invoiceCredit) }}&nbsp;€</span> }
              </span>
            } @else if (invoiceReason) {
              <span class="tile-reason">{{ invoiceReason }}</span>
            }
            @if (invoicing.error) { <span class="tile-reason error">Recalcul impossible : {{ invoicing.error }}</span> }
          }
          <span class="tile-foot">
            @if (invoiceAnomalies.length) {
              <button type="button" class="link-btn tile-sub anomalies-link" [class.blocking]="invoiceBlockingCount > 0" (click)="showAnomalies = !showAnomalies" [attr.aria-expanded]="showAnomalies">{{ invoiceAnomaliesLabel }}</button>
            }
            <span class="spacer"></span>
            <button mat-flat-button class="hdr-btn accent invoice-btn" (click)="invoiceNow()" [disabled]="!!invoiceBlockedReason" [disabledInteractive]="true" [matTooltip]="invoiceBlockedReason ?? 'Passage de facturation de ce dossier : aperçu, puis émission'">
              <mat-icon>receipt_long</mat-icon>Facturer maintenant
            </button>
          </span>
        </div>
      </div>

      @if (showAnomalies && invoiceAnomalies.length) {
        <div class="anomaly-panel">
          <div class="panel-head">
            <span>Anomalies de l'aperçu de facturation</span>
            <button type="button" class="icon-btn" (click)="showAnomalies = false" aria-label="Fermer" matTooltip="Fermer"><mat-icon>close</mat-icon></button>
          </div>
          @for (a of invoiceAnomalies; track $index) {
            <div class="anomaly-item" [class.blocking]="a.blocked">
              <span class="where">{{ anomalyWhere(a) }}</span>
              <span class="msg">{{ a.message }}</span>
              @if (a.blocked) { <span class="pill pill-anomaly">bloquante</span> }
            </div>
          }
        </div>
      }

      @if (adding) {
        <app-rental-add-line #addCard [customer]="customer" [isHt]="isHt" [periodNames]="periodNames" [present]="present" [saving]="saving" [vitrinePayerId]="distinctPayer ? (partyPayer?.id ?? null) : null" (save)="saveAddForm($event)" (saveReturn)="saveReturnForm($event)" (closed)="closeAddForm()"></app-rental-add-line>
        <!-- TEMPORAIRE (La Vitrine Médicale) : retirer ce bloc, [vitrinePayerId] ci-dessus, le dossier vitrine-rental-pick et son import. -->
        @if (addCard.mode === 'deliver' && !addCard.form.product) {
          <app-vitrine-rental-pick [payerId]="distinctPayer ? (partyPayer?.id ?? null) : null" (pick)="addCard.onSelectProduct({ id: $event })"></app-vitrine-rental-pick>
        }
      }

      @if (!draft) {
      <div class="table-card">
        <div class="table-header-bar">
          <div class="table-title"><mat-icon>bed</mat-icon><span>Matériels</span></div>
          <!-- Mêmes filtres de période que la liste des commandes ; un matériel est retenu si son jour de livraison (ou prévu) est dans la période. -->
          <div class="filters">
            <div class="date-filter" title="Matériels livrés (ou à livrer) dans la période">
              <span class="filter-label">Du</span>
              <app-select-date [date]="datstart" (dateChange)="dateChange($event, 'datstart')"></app-select-date>
            </div>
            <div class="date-filter">
              <span class="filter-label">Au</span>
              <app-select-date [date]="datend" (dateChange)="dateChange($event, 'datend')"></app-select-date>
            </div>
            <mat-button-toggle-group class="period-presets" [value]="activePeriod" (change)="setPeriod($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Raccourcis de période">
              @for (p of periods; track p.key) {
                <mat-button-toggle class="period-btn" [value]="p.key" [matTooltip]="p.title">{{ p.label }}</mat-button-toggle>
              }
            </mat-button-toggle-group>
          </div>
          <!-- Trois niveaux (JP 28/10) : à l'arrivée, le seul matériel en cours de location ; repris non soldé et clos lus à la demande. -->
          <div class="levels" role="group" aria-label="Matériels affichés">
            @for (lv of levelBoxes; track lv.key) {
              <mat-checkbox color="primary" class="level-box" [ngModel]="levels[lv.key]" (ngModelChange)="setLevel(lv.key, $event)" [matTooltip]="lv.tip">{{ lv.label }}{{ levelCount(lv.key) }}</mat-checkbox>
            }
          </div>
          <mat-button-toggle-group class="view-switch" [value]="display" (change)="setDisplay($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Présentation">
            <mat-button-toggle class="scope-btn view-btn" value="table"><mat-icon>table_rows</mat-icon>Tableau</mat-button-toggle>
            <mat-button-toggle class="scope-btn view-btn" value="planning"><mat-icon>view_timeline</mat-icon>Planning</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        @if (view.rows.length || view.outside.length) {
          <div class="grid" [hidden]="display === 'planning'">
            <div class="line entete">
              <div class="cell">Patient</div>
              <div class="cell">Livré le</div>
              <div class="cell">Repris le</div>
              <div class="cell">Facturé jusqu'au</div>
              <div class="cell num">Rang</div>
              <div class="cell">État</div>
              <div class="cell"></div>
              <div class="cell"></div>
            </div>

            @for (g of shownGroups; track g.key) {
              <div class="group-head">
                <span class="group-product">{{ g.title }}</span>
                <span class="sep">·</span><span class="group-price">{{ groupPrice(g) }}</span>
                <span class="spacer"></span>
                <span class="group-count">{{ plural(g.rows.length, 'matériel', 'matériels') }}</span>
                @if (g.article) { <span class="group-article">{{ g.article }}</span> }
              </div>
              @for (r of g.rows; track trackRow($index, r)) {
                <div class="line" [class.is-new]="r.isNew" [class.is-returned]="r.state === 'returned' && !r.anomalies.length" [title]="'Ligne #' + r.seq + (r.id ? ' · id ' + r.id : ' · non enregistrée')">
                  <div class="cell patient-cell">
                    @if (editingIndex === r.index) {
                      <input #memoInput class="text-input memo-input" [(ngModel)]="editingMemo" (keydown.enter)="saveMemo(r)" (keydown.escape)="cancelMemo()" aria-label="Patient" autocomplete="off" />
                      <button type="button" class="icon-btn ok" (click)="saveMemo(r)" aria-label="Enregistrer le patient" matTooltip="Enregistrer (Entrée)"><mat-icon>check</mat-icon></button>
                      <button type="button" class="icon-btn" (click)="cancelMemo()" aria-label="Annuler" matTooltip="Annuler (Échap)"><mat-icon>close</mat-icon></button>
                    } @else {
                      <span class="patient" [class.empty]="!r.patient && !store.beneficiary">{{ patientText(r.patient) }}</span>
                      @if (editable && !r.isNew) {
                        <button type="button" class="icon-btn edit" (click)="editMemo(r)" [disabled]="saving" aria-label="Modifier le patient" matTooltip="Modifier le patient"><mat-icon>edit</mat-icon></button>
                      }
                    }
                  </div>
                  <div class="cell date-cell">
                    @if (r.deliveredOn) { {{ fr(r.deliveredOn) }} }
                    @else if (r.planned) {
                      @if (r.plannedBl) { <button type="button" class="link-btn" (click)="openBl(r.plannedBl)" [matTooltip]="blTip(r.plannedBl)">prévue le {{ r.plannedOn ? fr(r.plannedOn) : '(date à fixer)' }}</button> }
                      @else { <span class="muted">prévue le {{ r.plannedOn ? fr(r.plannedOn) : '(date à fixer)' }}</span> }
                    }
                    @else { <span class="muted">à planifier</span> }
                  </div>
                  <div class="cell date-cell">
                    @if (r.backOn) { {{ fr(r.backOn) }} }
                    @else if (r.returnDoneOn) { <span class="muted">reprise signée le {{ fr(r.returnDoneOn) }}</span> }
                    @else if (r.returnPlanned) {
                      @if (r.returnPlannedBl) { <button type="button" class="link-btn" (click)="openBl(r.returnPlannedBl)" [matTooltip]="blTip(r.returnPlannedBl)">reprise prévue le {{ r.returnPlannedOn ? fr(r.returnPlannedOn) : '(date à fixer)' }}</button> }
                      @else { <span class="muted">reprise prévue le {{ r.returnPlannedOn ? fr(r.returnPlannedOn) : '(date à fixer)' }}</span> }
                    } @else { <span class="faint">—</span> }
                  </div>
                  <div class="cell date-cell billed-cell">
                    @if (r.server) {
                      @if (r.server.billed_until) { {{ fr(r.server.billed_until) }} } @else { <span class="muted">rien de facturé</span> }
                    }
                  </div>
                  <div class="cell num rank-cell">@if (r.server) { {{ rank(r.server) }} }</div>
                  <div class="cell state-cell">
                    @if (r.server) {
                      <span [class]="'pill ' + statusClass(r.server.status)">{{ statusLabel(r.server.status) }}</span>
                      @if (interruptedBadge(r.server)) { <span class="pill st-interrupted">Interrompu</span> }
                    } @else if (r.isNew) {
                      <span class="faint">non enregistrée</span>
                    } @else if (cycleError) {
                      <span class="muted state-missing" [matTooltip]="cycleError">état indisponible</span>
                      <button mat-stroked-button type="button" class="row-btn quiet retry-btn" (click)="store.reload()" [disabled]="store.firstLoad || store.refreshing">Réessayer</button>
                    } @else if (lifecycle && !store.refreshing) {
                      <span class="muted" matTooltip="Ligne absente de l'état de facturation rendu par le serveur">état inconnu</span>
                    } @else {
                      <mat-progress-spinner class="state-spin" mode="indeterminate" diameter="14" strokeWidth="2" color="primary" aria-label="État de facturation en cours de chargement"></mat-progress-spinner>
                    }
                    @if (r.anomalies.length) {
                      <button type="button" class="pill pill-anomaly anomaly-count" [class.blocked]="blockedRow(r)" [class.no-sheet]="!r.server" [matTooltip]="anomalyTip(r)" matTooltipClass="tooltip-multiline"
                        (click)="openSheet(r, 'anomalies')" [attr.aria-label]="plural(r.anomalies.length, 'anomalie', 'anomalies')">⚠ {{ r.anomalies.length }}</button>
                    }
                    @for (a of r.anomalies; track $index) {
                      @if (a.dates && editable) {
                        <button mat-stroked-button type="button" class="row-btn quiet" (click)="confirmDates(r)" [disabled]="saving" matTooltip="Garder ces dates telles quelles et lever l'avertissement">Dates correctes</button>
                      }
                    }
                    @if (r.datesChecked && !r.anomalies.length) {
                      <span class="pill pill-checked" [matTooltip]="checkedTitle(r)">✓ dates vérifiées</span>
                    }
                  </div>
                  <div class="cell action-cell">
                    @if (editable && r.canCollect) {
                      <button mat-stroked-button color="primary" type="button" class="row-btn" (click)="collect(r)" [disabled]="saving">Récupérer</button>
                    } @else if (editable && !r.isNew && r.state === 'to-plan') {
                      <span [matTooltip]="deliveryBlockedReason ?? ''"><button mat-stroked-button type="button" class="row-btn quiet" (click)="openDeliveryDialog([r.id])" [disabled]="saving || !!deliveryBlockedReason">Planifier</button></span>
                    }
                  </div>
                  <div class="cell menu-cell">
                    @if (!r.isNew) {
                      <span class="menu-hint" [matTooltip]="menuBlockedReason(r) ?? 'Décisions de facturation, fiche de la ligne'">
                        <button type="button" class="row-menu-btn" [matMenuTriggerFor]="rowMenu" [matMenuTriggerData]="{ r: r }" [disabled]="!!menuBlockedReason(r)" [attr.aria-label]="'Actions de la ligne ' + r.seq"><mat-icon>more_vert</mat-icon></button>
                      </span>
                    }
                  </div>
                </div>
              }
            }

            <!-- Reprises hors contrat : ligne louée négative (data.hors_contrat), seul son BL −n existe ; ni anomalie ni facture. -->
            @if (view.outside.length) {
              <div class="group-head">
                <span class="group-product">Reprises hors contrat</span>
                <span class="sep">·</span><span>matériel qu'aucun dossier ne suit, jamais facturé</span>
                <span class="spacer"></span>
                <span class="group-count">{{ plural(view.outside.length, 'reprise', 'reprises') }}</span>
              </div>
              @for (o of view.outside; track trackOutside($index, o)) {
                <div class="line" [class.is-new]="!o.id" [class.is-returned]="!!o.doneOn" [title]="'Ligne #' + o.seq + (o.id ? ' · id ' + o.id : ' · non enregistrée')">
                  <div class="cell patient-cell"><span class="patient" [class.empty]="!o.patient && !store.beneficiary">{{ patientText(o.patient) }}</span></div>
                  <div class="cell date-cell"><span class="faint">—</span></div>
                  <div class="cell date-cell">
                    @if (o.doneOn) { {{ fr(o.doneOn) }} }
                    @else if (o.planned) {
                      @if (o.plannedBl) { <button type="button" class="link-btn" (click)="openBl(o.plannedBl)" [matTooltip]="blTip(o.plannedBl)">reprise prévue le {{ o.plannedOn ? fr(o.plannedOn) : '(date à fixer)' }}</button> }
                      @else { <span class="muted">reprise prévue le {{ o.plannedOn ? fr(o.plannedOn) : '(date à fixer)' }}</span> }
                    }
                    @else { <span class="muted">reprise à planifier</span> }
                  </div>
                  <div class="cell"><span class="faint">—</span></div>
                  <div class="cell num"><span class="faint">—</span></div>
                  <div class="cell state-cell"><span class="pill pill-checked out-name" [matTooltip]="o.productName">{{ o.qty > 1 ? o.qty + ' × ' : '' }}{{ o.productName }}</span></div>
                  <div class="cell action-cell">
                    @if (editable && o.id && !o.doneOn && !o.planned) {
                      <span [matTooltip]="deliveryBlockedReason ?? ''"><button mat-stroked-button type="button" class="row-btn quiet" (click)="openDeliveryDialog([o.id])" [disabled]="saving || !!deliveryBlockedReason">Planifier</button></span>
                    }
                  </div>
                  <div class="cell menu-cell"></div>
                </div>
              }
            }
          </div>

          @if (display === 'table' && !shownGroups.length && !view.outside.length) {
            <div class="empty">Aucun matériel avec ces filtres.</div>
          }
          @if (hidden > 0) {
            <div class="hidden-note">{{ hiddenLabel }} · <button type="button" class="link-btn" (click)="showAll()">Tout afficher</button></div>
          }
        } @else if (display === 'table') {
          @if (closedLoaded) {
            <div class="empty">Aucun matériel sur ce contrat@if (editable) { : « Ajouter un matériel » pour commencer }.</div>
          } @else {
            <div class="empty">Aucun matériel en cours de location sur ce contrat.</div>
          }
        }

        @if (planningSeen) {
          <div class="planning-wrap" [hidden]="display !== 'planning'">
            <app-rental-planning mode="page" [visibleLineIds]="visibleIds" [focusLineId]="focusLineId" [docsReload$]="docsReload" [canDeliver]="editable && !saving" (deliver)="openAddForm($event)" [lineActions]="lineActions" (planDelivery)="planDeliveryFor($event)" (openBl)="openBl($event)"></app-rental-planning>
          </div>
        }
      </div>

      <!-- Commandes de vente du dossier (JP 30/10) : les produits vendus n'entrent plus au dossier ; chacune se livre dans le passage et se facture comme une F2. -->
      @if (saleOrders.length || saleOrdersError || salesToRetry) {
        <div class="table-card sale-orders">
          <div class="table-header-bar">
            <div class="table-title"><mat-icon>shopping_cart</mat-icon><span>Commandes de vente du dossier</span><span class="muted">(livrées avec le passage, facturées BL par BL)</span></div>
          </div>
          @if (saleOrdersError) { <div class="empty">{{ saleOrdersError }}</div> }
          <!-- Audit 31/10 #28 : produits vendus que la commande de vente a refusés, gardés jusqu'à « Réessayer ». -->
          @if (salesToRetry; as rt) {
            <div class="sale-order-row sale-retry">
              <mat-icon class="retry-icon">error_outline</mat-icon>
              <span class="sale-order-lines">{{ plural(rt.lines.length, 'produit vendu', 'produits vendus') }} en attente de commande de vente</span>
              <button mat-stroked-button type="button" (click)="retrySales()" [disabled]="saving" [disabledInteractive]="true" matTooltip="Les mettre dans la commande de vente du dossier"><mat-icon>refresh</mat-icon>Réessayer</button>
            </div>
          }
          @for (o of saleOrders; track o.id) {
            <div class="sale-order-row" [class.canceled]="saleOrderCanceled(o)">
              <a class="sale-order-ref" [routerLink]="['/sales/quotation', o.id]" target="_blank" matTooltip="Ouvrir la commande de vente (nouvel onglet)">Commande n° {{ o.id }}</a>
              <span class="pill" [class.pill-canceled]="saleOrderCanceled(o)" [matTooltip]="saleOrderCanceled(o) ? 'Commande annulée : elle ne se livre ni ne se facture plus' : ''">{{ saleOrderState(o) }}</span>
              <span class="sale-order-lines" [matTooltip]="saleOrderLines(o)">{{ saleOrderLines(o) }}</span>
              <span class="muted">{{ saleOrderBls(o) }}</span>
              <span class="num">{{ saleOrderAmount(o) }}</span>
            </div>
          }
        </div>
      }

      @if (view.others.length) {
        <!-- Ventes du dossier : quantités rendues par le serveur ; annuler une quantité passe par une décision 2106, jamais par un avoir à la main. -->
        <div class="table-card others">
          <div class="table-header-bar">
            <div class="table-title"><mat-icon>shopping_cart</mat-icon><span>Produits vendus</span><span class="muted">(facturés à l'achat, hors location)</span></div>
          </div>
          <div class="others-grid">
            <div class="line entete">
              <div class="cell">Désignation</div>
              <div class="cell num">Qté</div>
              <div class="cell num">Livré</div>
              <div class="cell num">Annulé</div>
              <div class="cell num">Facturé</div>
              <div class="cell num">À régler</div>
              <div class="cell num">Prix {{ taxLabel }}</div>
              <div class="cell num">Montant {{ taxLabel }}</div>
              <div class="cell"></div>
            </div>
            @for (o of view.others; track o.index) {
              <div class="line sale-row" [title]="'Ligne #' + o.seq">
                <div class="cell sale-name">
                  <span>{{ o.name }}</span>
                  @if (o.sale?.anomaly; as an) { <span class="pill pill-anomaly" [class.blocked]="o.sale.blocked" [matTooltip]="an">⚠ {{ o.sale.blocked ? 'bloquée' : 'anomalie' }}</span> }
                </div>
                <div class="cell num">{{ q(o.sale ? o.sale.qty : o.qty) }}</div>
                @if (o.sale; as s) {
                  <div class="cell num">{{ q(s.delivered_qty) }}</div>
                  <div class="cell num">{{ q(s.cancelled_qty) }}</div>
                  <div class="cell num">{{ q(s.billed_qty) }}</div>
                  <div class="cell num" [class.negative]="s.to_settle_qty < 0">{{ q(s.to_settle_qty) }}</div>
                } @else if (!lifecycle && !cycleError && o.id > 0) {
                  <div class="cell sale-wait"><mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary"></mat-progress-spinner></div>
                } @else {
                  <div class="cell sale-wait"><span class="faint">—</span></div>
                }
                <div class="cell num">{{ m(isHt ? o.unitTaxx : o.unitTaxi) }}</div>
                <div class="cell num">{{ m(isHt ? o.netTaxx : o.netTaxi) }}</div>
                <div class="cell menu-cell">
                  @if (o.sale) {
                    <button type="button" class="row-menu-btn" [matMenuTriggerFor]="saleMenu" [matMenuTriggerData]="{ o: o }" [attr.aria-label]="'Actions de la ligne ' + o.seq" matTooltip="Annuler une quantité vendue"><mat-icon>more_vert</mat-icon></button>
                  }
                </div>
              </div>
              @for (c of o.sale?.cancellations ?? []; track c.id) {
                <div class="line sale-history" [class.cancelled]="!!c.cancelled">
                  <div class="cell history-cell">
                    <span class="history-text">{{ cancellationText(c) }}</span>
                    @if (c.cancelled) {
                      <span class="history-cancel">{{ cancelledText(c) }}</span>
                    } @else {
                      <button mat-stroked-button type="button" class="row-btn quiet" (click)="cancelSaleCancellation(o, c)" matTooltip="Annuler cette annulation, avec un motif">Annuler</button>
                    }
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }

      <mat-menu #rowMenu="matMenu" class="rental-row-menu">
        <ng-template matMenuContent let-r="r">
          <button mat-menu-item (click)="openRange(r)" [disabled]="!!decisionBlockedReason(r)" [disabledInteractive]="true" [matTooltip]="decisionBlockedReason(r) ?? ''"><mat-icon>pause_circle</mat-icon>Interruption…</button>
          <button mat-menu-item (click)="openWindow(r, 'START')" [disabled]="!!startBlockedReason(r)" [disabledInteractive]="true" [matTooltip]="startBlockedReason(r) ?? ''"><mat-icon>first_page</mat-icon>Corriger le début (avant le BL)…</button>
          <button mat-menu-item (click)="openWindow(r, 'END')" [disabled]="!!decisionBlockedReason(r)" [disabledInteractive]="true" [matTooltip]="decisionBlockedReason(r) ?? ''"><mat-icon>last_page</mat-icon>Fin de facturation…</button>
          <button mat-menu-item (click)="openPrescription(r)" [disabled]="!!decisionBlockedReason(r)" [disabledInteractive]="true" [matTooltip]="decisionBlockedReason(r) ?? ''"><mat-icon>medical_information</mat-icon>Prescription…</button>
          <button mat-menu-item (click)="openSheet(r)"><mat-icon>description</mat-icon>Fiche de la ligne…</button>
          <button mat-menu-item (click)="showInPlanning(r)"><mat-icon>view_timeline</mat-icon>Voir dans le planning</button>
        </ng-template>
      </mat-menu>

      <!-- BL du dossier (non signés, signés récents) : fenêtre de livraison location, BL signé, board des tournées ; relus avec la pièce. -->
      <app-rental-bls [orderId]="id" [lines]="formGroup?.get('lines')?.value ?? []" [reload$]="docsReload" (openBl)="openBl($event)"></app-rental-bls>

      @if (rxFiles.length || hasRxLines) {
        <!-- Ordonnances : pièces du dossier jointes depuis « Prescription », vignettes comme la fiche article (consulter, télécharger). -->
        <div class="table-card ordonnances">
          <div class="table-header-bar">
            <div class="table-title"><mat-icon>description</mat-icon><span>Ordonnances du dossier</span><span class="muted">({{ rxFiles.length }})</span></div>
          </div>
          @if (rxFiles.length) {
            <div class="rx-carousel"><app-image-carousel [attachs]="rxFiles" [canEdit]="true"></app-image-carousel></div>
          } @else {
            <div class="empty small">Aucune ordonnance jointe · « Prescription » pour la saisir et joindre son fichier.</div>
          }
        </div>
      }

      <!-- Documents du dossier lui-même (bon de commande, contrat…) : composant de l'onglet « Documents attachés », sans les BL ; pièces des BL, ordonnances et pièces d'un matériel sur ce matériel (Planning). -->
      <div class="table-card documents">
        <div class="table-header-bar">
          <div class="table-title"><mat-icon>attach_file</mat-icon><span>Documents du dossier</span></div>
        </div>
        <app-quotationdocs [orderId]="id" [closedLinesLoaded]="closedLoaded" [withDeliveries]="false" [canEdit]="docsEditable" [exclude]="isLineFile"
          [loadOrderEventsSubject$]="docsReload" (openDelivery)="openDeliveryDialog()"></app-quotationdocs>
      </div>

      <!-- Factures et avoirs du dossier (/lifecycle), le plus récent en haut et par année : PDF ouvert ou téléchargé par le lien d'« Imprimer la facture », aucune action d'avoir ni d'annulation. -->
      <div class="table-card invoices">
        <div class="table-header-bar">
          <div class="table-title"><mat-icon>receipt_long</mat-icon><span>Factures et avoirs du dossier</span>
            @if (store.refreshing && lifecycle) { <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary" aria-label="Rechargement"></mat-progress-spinner> }
          </div>
          @if (lifecycle?.invoices?.length) {
            @let n = pickedInvoices.length;
            <div class="invoice-actions">
              <button mat-stroked-button class="hdr-btn" (click)="downloadPicked()" [disabled]="!n || !!batch" [disabledInteractive]="true"
                [matTooltip]="n ? 'Un PDF par pièce cochée, dans le dossier Téléchargements (le navigateur peut demander d\'autoriser les téléchargements multiples)' : 'Cochez les pièces à télécharger'">
                @if (batch) { <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary" aria-hidden="true"></mat-progress-spinner> } @else { <mat-icon>download</mat-icon> }
                @if (batch; as b) { Téléchargement {{ b.done + 1 }}/{{ b.total }}… } @else { Télécharger la sélection@if (n) { &nbsp;({{ n }}) } }
              </button>
            </div>
          }
        </div>
        @if (lifecycle; as lc) {
          @if (lc.invoices.length) {
            @let groups = invoiceGroups(lc.invoices);
            @let every = pickState(lc.invoices);
            <div class="invoices-grid">
              <div class="line entete">
                <div class="cell pick-cell"><mat-checkbox color="primary" [checked]="every === 'all'" [indeterminate]="every === 'some'" [disabled]="!hasPdf(lc.invoices) || !!batch" (change)="pickAll(lc.invoices, $event.checked)" aria-label="Cocher toutes les pièces" matTooltip="Tout cocher"></mat-checkbox></div>
                <div class="cell">Type</div>
                <div class="cell">N° (PDF)</div>
                <div class="cell"></div>
                <div class="cell">Dossier</div>
                <div class="cell">Patients</div>
                <div class="cell">Date</div>
                <div class="cell">Période (fin incluse)</div>
                <div class="cell num">Périodes</div>
                <div class="cell num">HT</div>
                <div class="cell num">TTC</div>
                <div class="cell">État</div>
              </div>
              @for (g of groups; track g.year) {
                @if (groups.length > 1) {
                  @let ys = pickState(g.invoices);
                  <div class="group-head year-head">
                    <span class="pick-cell"><mat-checkbox color="primary" [checked]="ys === 'all'" [indeterminate]="ys === 'some'" [disabled]="!hasPdf(g.invoices) || !!batch" (change)="pickAll(g.invoices, $event.checked)" [attr.aria-label]="'Cocher les pièces de ' + (g.year ?? 'sans date')" matTooltip="Cocher toute l'année"></mat-checkbox></span>
                    <span class="group-product">{{ g.year ?? 'Sans date de facture' }}</span>
                    <span class="sep">·</span>
                    <span class="group-count">{{ plural(g.invoices.length, 'pièce', 'pièces') }}</span>
                  </div>
                }
                @for (inv of g.invoices; track inv.id) {
                  @let who = docPatients(inv.memos);
                  @let missing = noPdf(inv);
                  <div class="line invoice-row" [class.is-credit]="inv.doc_type === 'AVOIR'">
                    <div class="cell pick-cell"><mat-checkbox color="primary" [checked]="picked.has(inv.id)" [disabled]="!!missing || !!batch" (change)="togglePick(inv, $event.checked)" [attr.aria-label]="'Cocher ' + (inv.doc_ref || 'la pièce ' + inv.id)"></mat-checkbox></div>
                    <div class="cell doc-type">{{ docTypeLabel(inv.doc_type) }}</div>
                    <div class="cell">
                      @if (missing) {
                        <span class="doc-ref" [matTooltip]="missing">{{ inv.doc_ref || '—' }}</span>
                      } @else {
                        <button type="button" class="link-btn pdf-link" (click)="openInvoicePdf(inv)" matTooltip="Ouvrir le PDF dans un nouvel onglet"><mat-icon>picture_as_pdf</mat-icon>{{ inv.doc_ref }}</button>
                      }
                    </div>
                    <div class="cell dl-cell">
                      @if (!missing) {
                        @if (fetching.has(inv.id)) {
                          <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary" aria-label="Téléchargement"></mat-progress-spinner>
                        } @else {
                          <button type="button" class="icon-btn" (click)="downloadInvoice(inv)" [disabled]="!!batch" [attr.aria-label]="'Télécharger ' + inv.doc_ref" matTooltip="Télécharger le PDF dans le dossier Téléchargements"><mat-icon>download</mat-icon></button>
                        }
                      }
                    </div>
                    <div class="cell"><a class="doc-link" [routerLink]="['/sales/quotation', inv.id]" matTooltip="Ouvrir la pièce dans l'écran des commandes">{{ inv.id }}</a></div>
                    <div class="cell patients" [attr.title]="who.title || null">{{ who.text || '—' }}</div>
                    <div class="cell date-cell">{{ inv.invoiced_on ? fr(inv.invoiced_on) : '—' }}</div>
                    <div class="cell">{{ invoicePeriod(inv) }}</div>
                    <div class="cell num">{{ inv.periods || '—' }}</div>
                    <div class="cell num">{{ m(inv.amount_taxx) }}</div>
                    <div class="cell num">{{ m(inv.amount_taxi) }}</div>
                    <div class="cell">{{ invoiceState(inv) }}</div>
                  </div>
                }
              }
            </div>
          } @else {
            <div class="empty small">Aucune facture ni avoir sur ce dossier.</div>
          }
        } @else if (cycleError) {
          <div class="empty small">Liste indisponible : {{ cycleError }} · <button type="button" class="link-btn" (click)="store.reload()">Réessayer</button></div>
        } @else {
          <div class="empty small wait"><mat-progress-spinner mode="indeterminate" diameter="16" strokeWidth="2" color="primary"></mat-progress-spinner>Chargement des factures…</div>
        }
      </div>

      <mat-menu #saleMenu="matMenu" class="rental-row-menu">
        <ng-template matMenuContent let-o="o">
          <button mat-menu-item (click)="openSaleCancellation(o)"><mat-icon>remove_circle_outline</mat-icon>Annuler une quantité…</button>
        </ng-template>
      </mat-menu>
      } @else {
        <!-- Brouillon : la page du dossier grisée, rien n'existe avant le premier matériel enregistré -->
        <div class="draft-greyed" inert>
          <div class="table-card"><div class="table-header-bar"><div class="table-title"><mat-icon>bed</mat-icon><span>Matériels</span></div></div><div class="empty">Aucun matériel : le dossier s'enregistre avec le premier matériel livré.</div></div>
          <div class="table-card"><div class="table-header-bar"><div class="table-title"><mat-icon>shopping_cart</mat-icon><span>Produits vendus</span><span class="muted">(facturés à l'achat, hors location)</span></div></div><div class="empty">Aucun produit vendu : les forfaits du contrat choisi s'y ajoutent.</div></div>
          <div class="table-card"><div class="table-header-bar"><div class="table-title"><mat-icon>local_shipping</mat-icon><span>BL du dossier</span></div></div><div class="empty">Aucun BL.</div></div>
          <div class="table-card"><div class="table-header-bar"><div class="table-title"><mat-icon>attach_file</mat-icon><span>Documents du dossier</span></div></div><div class="empty">Aucun document.</div></div>
          <div class="table-card"><div class="table-header-bar"><div class="table-title"><mat-icon>receipt_long</mat-icon><span>Factures et avoirs du dossier</span></div></div><div class="empty">Aucune facture ni avoir.</div></div>
        </div>
      }
    }
  }
</div>

<!-- Payeur différent du bénéficiaire : deux cartes, livré (vert) et facturé (jaune) ; sinon le nom seul (demande de JP du 29/10). -->
<ng-template #partiesTpl>
  @if (distinctPayer) {
    <div class="parties">
      <div class="party beneficiary">
        <span class="party-role">Bénéficiaire · livré</span>
        <span class="party-name"><button type="button" class="party-link" (click)="openParty(partyBeneficiary)" [disabled]="!partyBeneficiary?.id" matTooltip="Fiche du tiers bénéficiaire">{{ partyLabel(partyBeneficiary) || '…' }}</button></span>
        <span class="party-line">{{ delivText }}</span>
        @if (contactOf(partyBeneficiary); as t) { <span class="party-line">{{ t }}</span> }
      </div>
      <div class="party payer">
        <!-- Tous les dossiers que ce payeur règle : le bouton vit dans sa carte, pour qu'on comprenne de qui il s'agit (JP 29/10). -->
        <div class="party-head">
          <span class="party-role">Payeur · facturé</span>
          @if (!draft && customer?.id) {
            <a mat-stroked-button class="hdr-btn party-btn" [routerLink]="['/rental/payeur', customer.id]" [queryParams]="display === 'planning' ? { vue: 'planning' } : {}" matTooltip="Tous les dossiers de location payés par ce payeur, sur une même page"><mat-icon>folder_shared</mat-icon>Tous ses dossiers</a>
          }
        </div>
        <span class="party-name"><button type="button" class="party-link" (click)="openParty(partyPayer)" [disabled]="!partyPayer?.id" matTooltip="Fiche du tiers payeur">{{ partyLabel(partyPayer) || customerLabel }}</button></span>
        <span class="party-line">{{ billText }}</span>
        @if (contactOf(partyPayer); as t) { <span class="party-line">{{ t }}</span> }
      </div>
    </div>
  } @else {
    <div class="customer-name"><button type="button" class="party-link" (click)="openParty(draft ? draftPatient : customer)" [disabled]="!(draft ? draftPatient : customer)?.id" matTooltip="Fiche du tiers">{{ draft ? draftPatientName : customerLabel }}</button></div>
  }
</ng-template>
